import type { CardFilter } from '@/entities/board';

/** Filters set in the sheet (each selected option of status, deadline, assignment and each label). The text search is not counted: it stays visible. */
export function activeFilterCount(filter: CardFilter): number {
  return (
    filter.status.length +
    filter.deadline.length +
    filter.assignment.length +
    filter.labelIds.length
  );
}
